import { FaInstagram } from 'react-icons/fa';
import { CheckCircle } from 'lucide-react';
import { PreviewCardShell } from './PreviewCardShell';

interface InstagramProfileMockupProps {
  username?: string;
  name?: string;
  bio: string;
  posts?: string;
  followers?: string;
  following?: string;
  verified?: boolean;
  previewLabel?: string;
}

export const InstagramProfileMockup = ({
  username = 'username',
  name,
  bio,
  posts = '0',
  followers = '0',
  following = '0',
  verified = false,
  previewLabel = 'Instagram Profile Preview',
}: InstagramProfileMockupProps) => {
  return (
    <PreviewCardShell
      className="mb-3"
      bodyClassName="p-4"
      badgeClassName="bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737]"
      badge={<FaInstagram className="h-4 w-4 text-white" />}
      label={previewLabel}
    >
        <div className="flex gap-4 mb-4">
          {/* Profile picture with Instagram gradient ring */}
          <div className="flex-shrink-0">
            <div className="w-20 h-20 rounded-full p-0.5 bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]">
              <div className="w-full h-full rounded-full bg-gradient-to-br from-purple-400 to-pink-400" />
            </div>
          </div>

          {/* Stats */}
          <div className="flex-1 flex justify-around items-center">
            <div className="text-center">
              <div className="text-base font-bold text-zinc-50">{posts}</div>
              <div className="text-xs text-zinc-400">posts</div>
            </div>
            <div className="text-center">
              <div className="text-base font-bold text-zinc-50">{followers}</div>
              <div className="text-xs text-zinc-400">followers</div>
            </div>
            <div className="text-center">
              <div className="text-base font-bold text-zinc-50">{following}</div>
              <div className="text-xs text-zinc-400">following</div>
            </div>
          </div>
        </div>

        {/* Name and bio */}
        <div className="mb-4">
          {name && (
            <div className="flex items-center gap-1.5 mb-1">
              <h3 className="text-sm font-semibold text-zinc-50">{name}</h3>
              {verified && <CheckCircle className="w-4 h-4 text-blue-500" fill="currentColor" />}
            </div>
          )}
          <p className="mb-2 text-xs text-zinc-400">@{username}</p>
          <p className="text-sm whitespace-pre-wrap text-zinc-100">{bio}</p>
        </div>

        {/* Action buttons */}
        <div className="flex gap-2">
          <button className="flex-1 bg-blue-500 text-white text-sm font-semibold py-1.5 px-4 rounded-lg opacity-60 cursor-not-allowed">
            Follow
          </button>
          <button className="flex-1 rounded-lg border border-zinc-700 px-4 py-1.5 text-sm font-semibold text-zinc-100 opacity-60 cursor-not-allowed">
            Message
          </button>
        </div>
    </PreviewCardShell>
  );
};
